interface ISettingsValue {
	[key: string]: any
}

const SETTING_TYPE_ANSWERS_MODE = 'answersMode'
const SETTING_ANSWERS_MODE_DEFAULT = 'default'
const SETTING_ANSWERS_MODE_RANDOMIZE = 'randomize'
const SETTING_AVAILABLE_SKINS = 'availableSkins'

const SETTING_TYPE_SKIN = 'skin'
const SETTING_SKIN_DEFAULT = 1
const SETTING_SKIN_SPACE = 2
const SETTING_SKIN_HALLOWEEN = 3
const SETTING_SKIN_HOLIDAY = 4
const SETTING_SKIN_VALENTINES = 5
const SETTING_SKIN_UNDERWATER = 6
const SETTING_SKIN_APRIL_FOOLS = 7
const SETTING_SKIN_CARNIVAL = 8
const SETTING_SKIN_JUNGLE = 9
const SETTING_SKIN_SPORTS = 10
const SETTING_SKIN_BEACH = 11

const SETTING_TYPE_HIDE_STUDENT_NAMES = 'hideStudentNames'

const SETTING_TYPE_GAME_MODE = 'gameMode'
const SETTING_GAME_MODE_SYNC = 0
const SETTING_GAME_MODE_OWN_PACED = 1

const SETTING_TYPE_AUDIO = 'audio'
const SETTING_GAME_AUDIO_MUTED = 0
const SETTING_GAME_AUDIO_UNMUTED = 1
const SETTING_GAME_AUDIO_DEFAULT_VOLUME_VALUE = 0.2

const SETTING_TYPE_PAUSE = 'isPauseEnabled'
const SETTING_GAME_CANT_PAUSE = 0
const SETTING_GAME_CAN_PAUSE = 1

const SETTING_TYPE_TIMER_DISABLED = 'isTimerDisabled'
const SETTING_TIMER_DEFAULT = 0
const SETTING_TIMER_DISABLED_FROM_SESSION = 1
const SETTING_TIMER_DISABLED_FROM_CREATION = 2

const SETTING_TYPE_ANIMATIONS = 'areAnimationsEnabled'
const SETTING_ANIMATIONS_DISABLED = 0
const SETTING_ANIMATIONS_ENABLED = 1

const values: ISettingsValue = {
	[SETTING_TYPE_ANSWERS_MODE]: [SETTING_ANSWERS_MODE_DEFAULT, SETTING_ANSWERS_MODE_RANDOMIZE],
	[SETTING_TYPE_SKIN]: [
		SETTING_SKIN_DEFAULT,
		SETTING_SKIN_SPACE,
		SETTING_SKIN_HOLIDAY,
		SETTING_SKIN_VALENTINES,
		SETTING_SKIN_UNDERWATER,
		SETTING_SKIN_CARNIVAL,
		SETTING_SKIN_JUNGLE,
		SETTING_SKIN_SPORTS,
		SETTING_SKIN_BEACH,
	],
	[SETTING_TYPE_GAME_MODE]: [SETTING_GAME_MODE_SYNC, SETTING_GAME_MODE_OWN_PACED],
	[SETTING_TYPE_AUDIO]: [SETTING_GAME_AUDIO_MUTED, SETTING_GAME_AUDIO_UNMUTED, SETTING_GAME_AUDIO_DEFAULT_VOLUME_VALUE],
	[SETTING_TYPE_PAUSE]: [SETTING_GAME_CANT_PAUSE, SETTING_GAME_CAN_PAUSE],
	[SETTING_TYPE_TIMER_DISABLED]: [SETTING_TIMER_DEFAULT, SETTING_TIMER_DISABLED_FROM_SESSION, SETTING_TIMER_DISABLED_FROM_CREATION],
	[SETTING_TYPE_ANIMATIONS]: [SETTING_ANIMATIONS_DISABLED, SETTING_ANIMATIONS_ENABLED],
}

export default {
	values,
	SETTING_TYPE_ANSWERS_MODE,
	SETTING_ANSWERS_MODE_DEFAULT,
	SETTING_ANSWERS_MODE_RANDOMIZE,
	SETTING_AVAILABLE_SKINS,
	SETTING_TYPE_SKIN,
	SETTING_SKIN_DEFAULT,
	SETTING_SKIN_HALLOWEEN,
	SETTING_SKIN_SPACE,
	SETTING_SKIN_JUNGLE,
	SETTING_SKIN_SPORTS,
	SETTING_SKIN_HOLIDAY,
	SETTING_TYPE_HIDE_STUDENT_NAMES,
	SETTING_SKIN_VALENTINES,
	SETTING_SKIN_UNDERWATER,
	SETTING_SKIN_APRIL_FOOLS,
	SETTING_SKIN_CARNIVAL,
	SETTING_SKIN_BEACH,
	SETTING_TYPE_GAME_MODE,
	SETTING_GAME_MODE_SYNC,
	SETTING_GAME_MODE_OWN_PACED,
	SETTING_TYPE_AUDIO,
	SETTING_GAME_AUDIO_MUTED,
	SETTING_GAME_AUDIO_UNMUTED,
	SETTING_GAME_AUDIO_DEFAULT_VOLUME_VALUE,
	SETTING_TYPE_PAUSE,
	SETTING_GAME_CAN_PAUSE,
	SETTING_GAME_CANT_PAUSE,
	SETTING_TYPE_TIMER_DISABLED,
	SETTING_TIMER_DEFAULT,
	SETTING_TIMER_DISABLED_FROM_SESSION,
	SETTING_TIMER_DISABLED_FROM_CREATION,
	SETTING_TYPE_ANIMATIONS,
	SETTING_ANIMATIONS_DISABLED,
	SETTING_ANIMATIONS_ENABLED,
}
